import React, { Component } from 'react';

class CtaSingle extends Component {
   render() {
      return (
         <div className="flex cta-single">
            <div className="justify-center">
               <div className="container">
                  <div className="column">
                     <div className="cta-text-div">
                        <h3 className="text-center color-black">
                           Envío no incluido, por favor póngase en contacto para
                           cotizar la mejor opción.
                        </h3>
                     </div>
                     <div className="white-space-8"></div>
                     <div className="cta-btn-div">
                        <a
                           className="btn-ghost color-black"
                           href="https://api.whatsapp.com/send?phone=529983509562"
                           target="_blank"
                           rel="noopener noreferrer"
                        >
                           <div className="row align-center">
                              <i className="fab fa-whatsapp"></i>
                              <h4> &nbsp; Contáctanos</h4>
                           </div>
                        </a>
                     </div>
                     <div className="white-space-48"></div>
                  </div>
               </div>
            </div>
         </div>
      );
   }
}

export default CtaSingle;



// WEBPACK FOOTER //
// ./src/components/CTA/ctaSingle.js